import script from "./side-bar.vue?vue&type=script&lang=ts&setup=true"
export * from "./side-bar.vue?vue&type=script&lang=ts&setup=true"

import "./side-bar.vue?vue&type=style&index=0&id=75094fb0&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75094fb0"]])

export default __exports__